import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Kies je startplan <br/> Wij regelen alles, <underline>JIJ</underline> leunt achterover 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Later betalen uit omzet',
    [BillingMode.Stripe]: '(0)[Nu betalen];(1-inf)[Nu betalen (bespaar tot {{discount}})]',
  },
};
